export const BACKOFFICE_ACCESS = "backoffice_access";
export const CALL_CENTER_LIGHT_USER = "callcenter_light_user";
export const CALL_CENTER_USER = "callcenter";
export const CALL_MOD_RESTRICTED_USER = "restricted_reservation_modification";
export const EMAIL_ADMIN = "email-admin";
export const AI_USER = "ai-user";
